import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferCreate {
  constructor($scope, OfferService, UserService, GeoService) {
    $scope.tabs = ['1. Title & Synopsis', '2. Basic Infos', '3. Description'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.offer.supplier_id = ui.item.id;
          $scope.offer.user_contact_id = null;
          $scope.supplier_company = ui.item.value;
          $scope.$apply();
          $scope.update_supplier_data(ui.item.id);
        }
      });
    };

    $scope.update_supplier_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.supplier_contacts = data.contacts;
      });

      UserService.get_seller_trading_data(user_id).then(function(data) {
        $scope.offer.currency_id = data.currency_id;
        $scope.offer.origin = data.origin;
        $scope.offer.delivery = data.delivery;
        $scope.offer.packaging = data.packaging;
        $scope.offer.sample_available = data.sample_available;
        $scope.offer.min_quantity_truck = data.min_quantity_truck;
        $scope.offer.min_quantity_ship = data.min_quantity_ship;
        $scope.offer.min_quantity_self = data.min_quantity_self;
        $scope.offer.dap_country_id = data.dap_country_id;
        $scope.offer.dap_port = data.dap_port;
      });
    };

    $scope.$watch('offer.dap_country_id', function() {
      if ($scope.offer.dap_country_id) {
        GeoService.get_cities($scope.offer.dap_country_id).then(function(data) {
          $scope.shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.offer.dap_port}))
            $scope.offer.dap_port = null;
        });
      }
    });

    $scope.load_user_notes = function() {
      if ($scope.offer.supplier_id) {
        UserService.get_notes($scope.offer.supplier_id).then(function(data) {
          $scope.offer.notes = data.notes;
        });
      } else {
        alert('Please select a supplier first!');
      }
    };

    $scope.create_offer = function() {
      $scope.creating_offer = true;
      if (!$scope.offer.supplier_id) {
        $scope.form_error = 'Please select a supplier!';
        $scope.creating_offer = false;
      } else if (!$scope.offer.titleEN) {
        $scope.form_error = 'Please insert a Title (Megaepsilon)!';
        $scope.creating_offer = false;
      } else {
        $scope.form_error = '';
        $scope.offer.incoterms = {
          incoterms: _.pluck(_.filter($scope.incoterms, function(t) {
            return t.checked === true;
          }), 'id')
        };
        $scope.offer.cfr_countries = $scope.incoterms[0].checked ? $scope.cfr_countries : [];
        $scope.offer.dap_countries = $scope.incoterms[0].checked ? $scope.dap_countries : [];

        OfferService.save($scope.offer).then(function(data) {
          if (data.success) {
            $scope.created_offer_id = data.offer_id;
            $scope.create_mode = false;
          } else {
            $scope.form_error = data.message;
          }
          $scope.creating_offer = false;
        });
      }
    };

    $scope.create_new_offer = function() {
      $scope.offer = angular.copy(window.offer);
      $scope.selected_tab = 0;
      $scope.create_mode = true;
      $scope.supplier_company = '';
      $('.supplier_company').val('');
      $scope.offer.offer_type = $scope.offer_types[0].id;
      $scope.offer.quality = $scope.offer_qualities[0].id;
      $scope.offer.transaction_type = $scope.transaction_types[0].id;
      $scope.offer.bid_type = $scope.bid_types[0].id;
      $scope.offer.short_description = $scope.short_descriptions[0].id;
      $scope.offer.quantity = 0;
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '800px'
    };

    $scope.$watch('cfr_continent', function() {
      if ($scope.cfr_continent && $scope.cfr_continent !== '') {
        var group = $('select#cfr_countries').find('optgroup[label="' + $scope.cfr_continent + '"]');
        group.find('option').each(function() {
          $scope.cfr_countries.push($(this).attr('value'));
        });
      }
    });

    $scope.$watch('dap_continent', function() {
      if ($scope.dap_continent && $scope.dap_continent !== '') {
        var group = $('select#dap_countries').find('optgroup[label="' + $scope.dap_continent + '"]');
        group.find('option').each(function() {
          $scope.dap_countries.push($(this).attr('value'));
        });
      }
    });

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.create_mode = true;
      $scope.set_supplier_autocomplete($('input.supplier_company'));
      $scope.offer_types = window.offer_types;
      $scope.offer_qualities = window.offer_qualities;
      $scope.transaction_types = window.transaction_types;
      $scope.bid_types = window.bid_types;
      $scope.short_descriptions = window.short_descriptions;
      $scope.currencies = window.currencies;
      $scope.incoterms = window.incoterms;
      $scope.create_new_offer();
      $scope.cfr_countries = [];
      $scope.dap_countries = [];
    };

    $scope.init();
  }
}

OfferCreate.$inject = ['$scope', 'OfferService', 'UserService', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-create.ctrl.js